import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { addCluster } from 'RestAPIs/admin';

type AddRosterFunctionVariables = {
  brId: number;
  clusterId: number;
};

const useAddCluster = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, AddRosterFunctionVariables>(
    ({ brId, clusterId }) => addCluster(brId, clusterId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'rosterClusters',
          'list',
          variables.brId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddCluster;
